export enum LogActionType {
  'INFO',
  'ERROR',
}

export interface ILogger {
  exceptionAsync(error: Error)

  /**
   * Logs specific action type.
   * @param {LogActionType} actionType - Action Type
   * @param {Object} data - key - value pairs object.
   */
  logAsync(actionType: LogActionType, data: object)

  /**
   * Logs specific action type.
   * @param {Object} data - key - value pairs object.
   */
  errorAsync(data: object)

  /**
   * Logs specific action type.
   * @param {String} errorType - string, error type.
   * @param {Object} data - key - value pairs object.
   */
  errorTypedAsync(errorType: string, data?: object)

  /**
   * Logs specific action type.
   * @param {Object} data - key - value pairs object.
   */
  infoAsync(data: object)

  /**
   * Logs specific action type.
   * @param {String} infoType - string, info type.
   * @param {Object} data - key - value pairs object.
   */
  infoTypedAsync(infoType: string, data?: object)
}
